module.exports = __webpack_public_path__ + "media/images/uncdf-2-ab7c17f628b75318fe1cbe74bae2d385.png";